import { render } from "./App.vue?vue&type=template&id=f73520fc&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=f73520fc&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f73520fc"]])

export default __exports__